<template>
    <div>
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 col-8 align-self-center">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active">サービス一覧</li>
            </ol>
          </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row">
          <div class="col-12">
            <!-- Column -->
            <div class="card">
              <div class="card-body">
                <div class="dataTables_wrapper dt-bootstrap no-footer">
                  <div class="row">
                    <div class="col-1">
                      <div class="p-xl-3">
                        <button type="submit" class="btn btn-success btn-circle" :disabled="isProcessing"
                                @click="search">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-3">
                      <div class="data-actions">
                        <router-link to="/custom-service-code_new" class="btn btn-rounded btn-outline-info">
                          <i class="fa fa-plus"></i>新規登録する
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="page">
                    <div class="col-sm-12">
                      <div class="table-responsive" v-if="page.data.length > 0">
                        <table id="myTable" class="table table-sm table-bordered">
                          <thead>
                          <tr>
                            <th>サービス</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="template in page.data" :key="template.id">
                            <td>
                              <router-link :to="`/custom-service-code_edit/${template.id}`">{{ template.display_name }}</router-link>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-else>
                        <div class="alert alert-warning">
                          <p><i class="fa fa-info-circle p-r-10"></i>該当するデータが見つかりませんでした。</p>
                          <p>検索のヒント</p>
                          <ul>
                            <li>
                              検索条件を変更してみてください。
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <pagination :page="page" v-if="page && page.data.length > 0" @change="changePage"/>
                </div>
              </div>
            </div>
            <!-- Column -->
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination'
import api from '@/libs/Api'
import constants from '@/constants'
import { useExecutor } from '@/libs/Executor'

// Component state
const page = ref(null)
const isProcessing = ref(false)

// Get the executor utility
const { exec } = useExecutor()

// Methods
const changePage = (pageNum) => {
  search(pageNum)
}

const search = (pageNum = 1) => {
  exec(() => {
    isProcessing.value = true
    return api.getCustomServiceCode(constants.QUERY_MODE_PAGING, pageNum)
      .then(res => {
        page.value = res
      })
      .finally(() => {
        isProcessing.value = false
      })
  })
}

// Mount hook
onMounted(() => {
  search()
})
</script>

<style scoped>
</style>
